const dateFormatter = new Intl.DateTimeFormat(navigator.language, {
  weekday: "short",
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  timeZoneName: "short",
});

for (const time of document.querySelectorAll("time[data-local-datetime]")) {
  const value = time.getAttribute("datetime");
  if (!value || /^\d{4}-\d{2}-\d{2}$/.test(value)) continue;
  const date = new Date(value);
  if (!Number.isNaN(date.valueOf())) time.textContent = dateFormatter.format(date);
}
